import { post } from "../../service/api";
export const CreateNegdiOrderPaymentWithCard = async (
  invoiceId,
  cardId,
  pin
) => {
  try {
    const response = await post(`/negdi/order/paymentWithCard`, {
      invoiceId,
      cardId,
      pin,
    });
    if (response && response.data) return response.data;
    else return null;
  } catch (error) {
    console.error("Error createNegdiOrderPaymentWithCard:", error);
    return null;
  }
};
